export default "https://assets-v2.scaler.com/packs/files/AskQuestions.907cb1.webp";